export interface TokenPayload {
  discordId: string;
  displayName: string;
  iat: number;
  exp: number;
}

const TOKEN_KEY = 'ggm_portal_token';

export function consumeTokenFromUrl(): string | null {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    // Strip token from URL without a reload, but keep other query params
    params.delete('token');
    const remaining = params.toString();
    const clean = window.location.pathname + (remaining ? `?${remaining}` : '');
    window.history.replaceState({}, '', clean);
    return token;
  }
  return getStoredToken();
}

export function getStoredToken(): string | null {
  // localStorage so the session survives iOS Safari reloads (e.g. returning from the native photo picker) that wipe sessionStorage; sessionStorage kept as a fallback for legacy in-flight sessions.
  return localStorage.getItem(TOKEN_KEY) ?? sessionStorage.getItem(TOKEN_KEY);
}

export function decodeToken(token: string): TokenPayload | null {
  try {
    const [, body] = token.split('.');
    // base64url → base64
    const base64 = body.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64)) as TokenPayload;
  } catch {
    return null;
  }
}

export function isExpired(payload: TokenPayload): boolean {
  return payload.exp < Math.floor(Date.now() / 1000);
}
